export enum UserAccessRole {
    PRISM_REGTOOLS_ANNOTATIONS = 'PRISM_REGTOOLS_ANNOTATIONS',
    PRISM_REGTOOLS_DEREGULATED = 'PRISM_REGTOOLS_DEREGULATED',
    PRISM_REGTOOLS_EUP = 'PRISM_REGTOOLS_EUP',
    PRISM_REGTOOLS_MAINTENANCE = 'PRISM_REGTOOLS_MAINTENANCE',
    PRISM_REGTOOLS_PERMIT = 'PRISM_REGTOOLS_PERMIT',
    PRISM_REGTOOLS_REPORTING = 'PRISM_REGTOOLS_REPORTING',
    PRISM_REGULATORY_ADMIN = 'PRISM_REGULATORY_ADMIN',
    PRISM_REGTOOLS_DELETE = 'PRISM_REGTOOLS_DELETE',
    PRISM_REGTOOLS_RIM = 'PRISM_REGTOOLS_RIM',
    PRISM_REGTOOLS_SCRIPT_UPDATE = 'PRISM_REGTOOLS_SCRIPT_UPDATE',
    PRISM_REGULATORY_AFFAIRS_PRISM_STEWARD = 'PRISM_REGULATORY_AFFAIRS_PRISM_STEWARD',
    WWS_REGULATORY_ADMIN = 'WWS_REGULATORY_ADMIN'
}

export class UserAccessValue {
    HasAccess: boolean;

    constructor(hasAccess: boolean) {
        this.HasAccess = hasAccess;
    }

    public Update(value: UserAccessValue) {
        this.HasAccess = value.HasAccess;
    }

    public Value(): boolean {
        return this.HasAccess;
    }
}

export class UserAccess {
    public CanDoReports: UserAccessValue;
    public CanDoPermits: UserAccessValue;

    constructor() {
        this.CanDoReports = new UserAccessValue(false);
        this.CanDoPermits = new UserAccessValue(false);
    }

    public Initialize(roles: UserAccessRole[]) {
        if (roles === undefined || roles.length === 0) {
            return;
        }

        this.CanDoReports.Update(new UserAccessValue(roles.indexOf(UserAccessRole.PRISM_REGTOOLS_REPORTING) > -1));
        this.CanDoPermits.Update(new UserAccessValue(roles.indexOf(UserAccessRole.PRISM_REGTOOLS_PERMIT) > -1));
    }
}
